import { render } from "./VisualizacaoTab.vue?vue&type=template&id=787d1598&scoped=true"
import script from "./VisualizacaoTab.vue?vue&type=script&lang=js"
export * from "./VisualizacaoTab.vue?vue&type=script&lang=js"

import "./VisualizacaoTab.vue?vue&type=style&index=0&id=787d1598&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-787d1598"]])

export default __exports__